import packageJson from '../../package.json';

/**
 * Application version information
 * Automatically pulled from package.json version
 */
export const APP_VERSION = packageJson.version;

/**
 * Version format for display
 * Example: "1.0.1" -> "v1.0.1"
 */
export const getFormattedVersion = (): string => {
  return `v${APP_VERSION}`;
};

/**
 * Full copyright string with version and current year
 */
export const getCopyrightWithVersion = (): string => {
  return `Copyright ${new Date().getFullYear()} Volt Finance. ${getFormattedVersion()}`;
};
